import IManualInputFormData from '../../../../../../common/interfaces/IManualInputFormData';
import IValidationResult from '../../../../../../common/interfaces/IValidationResult';
import ValidationService from '../../../../../../common/services/validation';
import GeneralValidationSchema from './manual-input-form.validation.service';

const validateInfos = (
    manualInputData: IManualInputFormData,
): IValidationResult => {
    return ValidationService.validate(GeneralValidationSchema, manualInputData);
};

const ManualInputFormService = {
    validateInfos,
};

export default ManualInputFormService;
